import { Header } from "./Header";
import { Footer } from "./Footer";
import { CompareBar } from "./CompareBar";

export function Layout({ children }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 animate-fade-in">{children}</main>
      <Footer />
      <CompareBar />
    </div>
  );
}
